import React from "react";
import styled from "styled-components";
import { ImageLoader } from "@loanbossinc/component-library";

const defaultLogoUrl = process.env.PUBLIC_URL + "/images/default-tile.png";
const defaultBannerUrl = process.env.PUBLIC_URL + "/images/default-banner.png";

const ProfileImageContainer = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-around;
    box-shadow: ${({ authenticated }) => (authenticated ? "0px 10px 20px #adaeae" : "none")} ;
`;

const ImageBanner = styled.div`
    width: 100%;
    height: calc(320px + 52px + 2em);
`;

const ThumbnailContainer = styled.div`
    transform: translate(3em, -9em);
    background: white;
    display: flex;
    z-index: 1;
    min-height: 80px;
    min-width: 80px;
    max-width: 120px;
    box-shadow: 0px 10px 20px 0px #ADAEAE40;
    border-radius: 4px;
    padding: 1em;
`;

const StyledThumbnailImgLoader = styled(ImageLoader)`&& {
    object-fit: cover;
    height: 80px;
    width: 100%;
}`;

const HeaderComponent = ({ banner, logo, authenticated, excludeLogo }) => (
  <ProfileImageContainer authenticated={authenticated}>
    <ImageBanner>
      <ImageLoader
        src={banner}
        defaultImage={defaultBannerUrl}
        height="320px"
        width="100%"
      />
    </ImageBanner>
    {
      excludeLogo ?
        null :
        <ThumbnailContainer>
          <StyledThumbnailImgLoader src={logo} defaultImage={defaultLogoUrl} height="100%" width="100%" />
        </ThumbnailContainer>
    }
  </ProfileImageContainer>
);

export default (HeaderComponent);
